// @mui
import { MenuItem, Stack } from '@mui/material';
import { useState } from 'react';

import { IconButtonAnimate } from '../../../components/animate';
// components
import Image from '../../../components/image';
import MenuPopover from '../../../components/menu-popover';
// locales
import { useLocales } from '../../../locales';

const LanguagePopover = () => {
  const { allLangs, currentLang, onChangeLang } = useLocales();

  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleChangeLang = (newLang: string) => {
    onChangeLang(newLang);
    handleClosePopover();
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          height: 40,
          width: 40,
          ...(openPopover && {
            bgcolor: 'action.selected',
          }),
        }}
      >
        <Image alt={currentLang.label} disabledEffect src={currentLang.icon} />
      </IconButtonAnimate>

      <MenuPopover
        onClose={handleClosePopover}
        open={openPopover}
        sx={{ width: 180 }}
      >
        <Stack spacing={0.75}>
          {allLangs.map((option) => (
            <MenuItem
              key={option.value}
              onClick={() => handleChangeLang(option.value)}
              selected={option.value === currentLang.value}
            >
              <Image
                alt={option.label}
                disabledEffect
                src={option.icon}
                sx={{ mr: 2, width: 28 }}
              />

              {option.label}
            </MenuItem>
          ))}
        </Stack>
      </MenuPopover>
    </>
  );
};

export default LanguagePopover;
